import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--marker-peach)";

const ROTATE_VALUE_TOP = 0;
const ROTATE_VALUE_RIGHT = 90;
const ROTATE_VALUE_BOTTOM = 180;
const ROTATE_VALUE_LEFT = 270;

enum PinSide {
    Top = "top",
    Right = "right",
    Bottom = "bottom",
    Left = "left"
}

interface Props extends IconProps {
    side?: PinSide;
}

function calculateRotationByPosition(side: PinSide): number {
    switch (side) {
        case PinSide.Top:
            return ROTATE_VALUE_TOP;
        case PinSide.Right:
            return ROTATE_VALUE_RIGHT;
        case PinSide.Bottom:
            return ROTATE_VALUE_BOTTOM;
        case PinSide.Left:
            return ROTATE_VALUE_LEFT;
        // no default
    }
}

function IconPinIndicator({
    class: cssClass,
    color,
    side = PinSide.Top
}: Props) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const rotation = calculateRotationByPosition(side);

    return (
        <svg class={cssClass} width="4" height="5" viewBox="0 0 4 5" fill="none" style={{ transform: `rotate(${rotation}deg)` }} xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M2.5 2a.5.5 0 0 0-1 0h1zm-1 0v3h1V2h-1z"/>
            <circle fill={fill} cx="2" cy="1.5" r="1.5"/>
        </svg>
    );
}

export default IconPinIndicator;
export { PinSide };
